import { EVENT_NAME } from '@leagueplatform/analytics';
import { MasonryNodeResponse } from '#types/get-masonry-node.ts';

export const mockMasonryFormsNode: MasonryNodeResponse = {
  data: {
    attributes: {
      node: {
        locatorId: 'core$demo-form$root',
        namespace: 'default',
        type: 'verticalLayout',
        properties: {
          isSemanticList: false,
        },
        actions: {
          onLoad: {
            analytics: {
              event_name: EVENT_NAME.SCREEN_LOADED,
              payload: {
                detail: 'a demo form',
                impression_id: '90f54b79f72db21d15ea2309b259e8f4',
                node: {
                  id: 'core$demo-form$root',
                  label: 'Demo form v2 root node',
                  type: 'verticalLayout',
                },
                product_area: 'masonry',
                screen_name: 'demo-form',
                sub_product_area: 'forms',
              },
            },
            namespace: 'default',
            payload: {},
            type: 'onLoad',
          },
        },
      },
    },
    id: 'core$demo-form$root',
    relationships: {
      sections: {
        data: [
          {
            id: 'core$demo-form$root-section-items',
            type: 'node-section',
          },
        ],
      },
    },
    type: 'node-data',
  },
  included: [
    {
      attributes: {
        name: 'items',
      },
      id: 'core$demo-form$root-section-items',
      relationships: {
        nodes: {
          data: [
            {
              id: 'core$demo-form$demoFormHeader',
              type: 'node-data',
            },
            {
              id: 'core$demo-form$demoFormWrapper',
              type: 'node-data',
            },
            {
              id: 'core$demo-form$demoFormFooter',
              type: 'node-data',
            },
          ],
        },
      },
      type: 'node-section',
    },
    {
      attributes: {
        node: {
          locatorId: 'core$demo-form$demoFormHeader',
          namespace: 'default',
          type: 'heroBanner',
          properties: {
            body: 'Spen',
            buttonLabel: 'Click Me',
            curved: false,
            eyebrow: 'Eyebrow text',
            heading: 'Welcome, this is a heroBanner!',
            includeSafeArea: false,
          },
          actions: {
            onButtonClick: {
              analytics: {
                event_name: EVENT_NAME.BUTTON_CLICKED,
                payload: {
                  detail: 'header',
                  impression_id: '90f54b79f72db21d15ea2309b259e8f4',
                  node: {
                    id: 'core$demo-form$demoFormHeader',
                    label: 'Hero Banner',
                    parent_label: 'Demo form v2 root node',
                    parent_type: 'verticalLayout',
                    type: 'heroBanner',
                  },
                  product_area: 'masonry',
                  screen_name: 'demo-form',
                  sub_product_area: 'form',
                },
              },
              namespace: 'default',
              payload: {
                url: 'https://www.league.com/ca',
              },
              type: 'deeplink',
            },
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  detail: 'header',
                  impression_id: '90f54b79f72db21d15ea2309b259e8f4',
                  node: {
                    id: 'core$demo-form$demoFormHeader',
                    label: 'Hero Banner',
                    parent_label: 'Demo form v2 root node',
                    parent_type: 'verticalLayout',
                    type: 'heroBanner',
                  },
                  product_area: 'masonry',
                  screen_name: 'demo-form',
                  sub_product_area: 'form',
                },
              },
              namespace: 'default',
              payload: {},
              type: 'onLoad',
            },
          },
        },
      },
      id: 'core$demo-form$demoFormHeader',
      links: {
        self: '/v1/masonry-node/core$demo-form$demoFormHeader?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4\u0026test=test_param',
      },
      type: 'node-data',
    },
    {
      attributes: {
        node: {
          locatorId: 'core$demo-form$demoFormWrapper',
          namespace: 'default',
          type: 'form',
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  detail: 'a demo form wrapper rendered',
                  impression_id: '90f54b79f72db21d15ea2309b259e8f4',
                  node: {
                    id: 'core$demo-form$demoFormWrapper',
                    label: 'Form Wrapper',
                    parent_label: 'Demo form v2 root node',
                    parent_type: 'verticalLayout',
                    type: 'form',
                  },
                  product_area: 'masonry',
                  screen_name: 'demo-form',
                  sub_product_area: 'forms',
                },
              },
              namespace: 'default',
              payload: {},
              type: 'onLoad',
            },
          },
        },
      },
      id: 'core$demo-form$demoFormWrapper',
      links: {
        self: '/v1/masonry-node/core$demo-form$demoFormWrapper?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4\u0026test=test_param',
      },
      relationships: {
        sections: {
          data: [
            {
              id: 'core$demo-form$demoFormWrapper-section-layout',
              type: 'node-section',
            },
          ],
        },
      },
      type: 'node-data',
    },
    {
      attributes: {
        name: 'layout',
      },
      id: 'core$demo-form$demoFormWrapper-section-layout',
      relationships: {
        nodes: {
          data: [
            {
              id: 'core$demo-form$demoFormFieldsVerticalLayout',
              type: 'node-data',
            },
          ],
        },
      },
      type: 'node-section',
    },
    {
      attributes: {
        node: {
          locatorId: 'core$demo-form$demoFormFieldsVerticalLayout',
          namespace: 'default',
          type: 'verticalLayout',
          properties: {
            isSemanticList: false,
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  detail: 'a demo form',
                  impression_id: '90f54b79f72db21d15ea2309b259e8f4',
                  node: {
                    id: 'core$demo-form$demoFormFieldsVerticalLayout',
                    label: 'Form fields vertical layout',
                    parent_label: 'Form Wrapper',
                    parent_type: 'form',
                    type: 'verticalLayout',
                  },
                  product_area: 'masonry',
                  screen_name: 'demo-form',
                  sub_product_area: 'forms',
                },
              },
              namespace: 'default',
              payload: {},
              type: 'onLoad',
            },
          },
        },
      },
      id: 'core$demo-form$demoFormFieldsVerticalLayout',
      links: {
        self: '/v1/masonry-node/core$demo-form$demoFormFieldsVerticalLayout?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4\u0026test=test_param',
      },
      relationships: {
        sections: {
          data: [
            {
              id: 'core$demo-form$demoFormFieldsVerticalLayout-section-items',
              type: 'node-section',
            },
          ],
        },
      },
      type: 'node-data',
    },
    {
      attributes: {
        name: 'items',
      },
      id: 'core$demo-form$demoFormFieldsVerticalLayout-section-items',
      relationships: {
        nodes: {
          data: [
            {
              id: 'core$demo-form$demoFormTextInputRequired',
              type: 'node-data',
            },
            {
              id: 'core$demo-form$demoFormTextInputOptional',
              type: 'node-data',
            },
            {
              id: 'core$demo-form$demoFormTextInputMoney',
              type: 'node-data',
            },
            {
              id: 'core$demo-form$demoFormTextInputEmail',
              type: 'node-data',
            },
            {
              id: 'core$demo-form$demoFormTextInputPassword',
              type: 'node-data',
            },
            {
              id: 'core$demo-form$demoFormTextInputTelephone',
              type: 'node-data',
            },
            {
              id: 'core$demo-form$demoFormTextInputDatePicker',
              type: 'node-data',
            },
            {
              id: 'core$demo-form$demoFormTextInputReadonly',
              type: 'node-data',
            },
            {
              id: 'core$demo-form$demoFormSelectInput',
              type: 'node-data',
            },
            {
              id: 'core$demo-form$demoFormSelectInputGrouped',
              type: 'node-data',
            },
            {
              id: 'core$demo-form$demoFormRadioGroupInline',
              type: 'node-data',
            },
            {
              id: 'core$demo-form$demoFormRadioGroupRow',
              type: 'node-data',
            },
            {
              id: 'core$demo-form$demoFormRadioGroupRowDisabled',
              type: 'node-data',
            },
            {
              id: 'core$demo-form$demoFormCheckboxGroupInline',
              type: 'node-data',
            },
            {
              id: 'core$demo-form$demoFormCheckboxGroupRow',
              type: 'node-data',
            },
            {
              id: 'core$demo-form$demoFormCheckboxGroupRowOptional',
              type: 'node-data',
            },
            {
              id: 'core$demo-form$demoFormCheckboxGroupRowDisabled',
              type: 'node-data',
            },
            {
              id: 'core$demo-form$demoFormConditionalStack',
              type: 'node-data',
            },
            {
              id: 'core$demo-form$demoFormSelectInputDataProcessorBehavior',
              type: 'node-data',
            },
            {
              id: 'core$demo-form$demoFormSubmitButton',
              type: 'node-data',
            },
          ],
        },
      },
      type: 'node-section',
    },
    {
      attributes: {
        node: {
          namespace: 'default',
          type: 'textInput',
          properties: {
            formFieldProperties: {
              formFieldId: 'textInputRequired',
              formFieldType: 'text',
              formId: 'demo-form',
              hideLabel: false,
              hint: 'Text input hint',
              label: 'First name',
              showOptionalFlag: false,
              tooltipContent: 'Tooltip content',
              tooltipIcon: 'statusInformationCircle',
              tooltipLabel: 'tooltip label',
              validationRules: [
                {
                  payload: {
                    required: true,
                  },
                  statusMessage: 'web',
                  statusType: 'error',
                  validationType: 'required',
                },
              ],
            },
            inputStatus: 'neutral',
            maxLines: 1,
            placeholder: 'Enter your first name!',
            value: 'Spen',
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: 'demo-value',
                    name: 'demo-value',
                    system: 'demo-value',
                  },
                  detail: 'text input',
                  impression_id: '90f54b79f72db21d15ea2309b259e8f4',
                  node: {
                    id: 'core$demo-form$demoFormTextInputRequired',
                    label: 'textInputRequired',
                    parent_label: 'Form fields vertical layout',
                    parent_type: 'verticalLayout',
                    type: 'textInput',
                  },
                  product_area: 'masonry',
                  screen_name: 'demo-form',
                  sub_product_area: 'form',
                },
              },
              namespace: 'default',
              payload: {},
              type: 'onLoad',
            },
          },
        },
      },
      id: 'core$demo-form$demoFormTextInputRequired',
      links: {
        self: '/v1/masonry-node/core$demo-form$demoFormTextInputRequired?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4\u0026test=test_param',
      },
      type: 'node-data',
    },
    {
      attributes: {
        node: {
          locatorId: 'core$demo-form$demoFormTextInputOptional',
          namespace: 'default',
          type: 'textInput',
          properties: {
            formFieldProperties: {
              formFieldId: 'textInputOptional',
              formFieldType: 'text',
              formId: 'demo-form',
              hideLabel: false,
              hint: 'Text input hint',
              label: 'Last Name',
              showOptionalFlag: true,
              tooltipContent: 'Tooltip content',
              tooltipIcon: 'statusInformationCircle',
              tooltipLabel: 'tooltip label',
            },
            inputStatus: 'neutral',
            maxLines: 1,
            placeholder: 'Enter your last name!',
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: 'demo-value',
                    name: 'demo-value',
                    system: 'demo-value',
                  },
                  detail: 'last name',
                  impression_id: '90f54b79f72db21d15ea2309b259e8f4',
                  node: {
                    id: 'core$demo-form$demoFormTextInputOptional',
                    label: 'textInputOptional',
                    parent_label: 'Form fields vertical layout',
                    parent_type: 'verticalLayout',
                    type: 'textInput',
                  },
                  product_area: 'masonry',
                  screen_name: 'demo-form',
                  sub_product_area: 'form',
                },
              },
              namespace: 'default',
              payload: {},
              type: 'onLoad',
            },
          },
        },
      },
      id: 'core$demo-form$demoFormTextInputOptional',
      links: {
        self: '/v1/masonry-node/core$demo-form$demoFormTextInputOptional?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4\u0026test=test_param',
      },
      type: 'node-data',
    },
    {
      attributes: {
        node: {
          locatorId: 'core$demo-form$demoFormTextInputMoney',
          namespace: 'default',
          type: 'textInput',
          properties: {
            formFieldProperties: {
              formFieldId: 'textInputMoney',
              formFieldType: 'number',
              formId: 'demo-form',
              hideLabel: false,
              label: 'Salary',
              showOptionalFlag: false,
              validationRules: [
                {
                  payload: {
                    required: true,
                  },
                  statusMessage: 'This field is required',
                  statusType: 'error',
                  validationType: 'required',
                },
              ],
            },
            inputStatus: 'neutral',
            leadingAddon: {
              type: 'icon',
              value: 'descriptiveMoneyBill',
            },
            leadingContent: {
              type: 'text',
              value: '$',
            },
            maxLines: 1,
            placeholder: 'Enter your salary!',
            value: '30000',
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: 'demo-value',
                    name: 'demo-value',
                    system: 'demo-value',
                  },
                  detail: 'salary input',
                  impression_id: '90f54b79f72db21d15ea2309b259e8f4',
                  node: {
                    id: 'core$demo-form$demoFormTextInputMoney',
                    label: 'textInputMoney',
                    parent_label: 'Form fields vertical layout',
                    parent_type: 'verticalLayout',
                    type: 'textInput',
                  },
                  product_area: 'masonry',
                  screen_name: 'demo-form',
                  sub_product_area: 'form',
                },
              },
              namespace: 'default',
              payload: {},
              type: 'onLoad',
            },
          },
        },
      },
      id: 'core$demo-form$demoFormTextInputMoney',
      links: {
        self: '/v1/masonry-node/core$demo-form$demoFormTextInputMoney?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4\u0026test=test_param',
      },
      type: 'node-data',
    },
    {
      attributes: {
        node: {
          locatorId: 'core$demo-form$demoFormTextInputEmail',
          namespace: 'default',
          type: 'textInput',
          properties: {
            formFieldProperties: {
              formFieldId: 'textInputEmail',
              formFieldType: 'email',
              formId: 'demo-form',
              hideLabel: false,
              label: 'Email',
              showOptionalFlag: false,
              validationRules: [
                {
                  payload: {
                    required: true,
                  },
                  statusMessage: 'This field is required',
                  statusType: 'error',
                  validationType: 'required',
                },
                {
                  payload: {
                    pattern: '^[^@]+@[^@]+\\.[^@]+$',
                  },
                  statusMessage: 'The email is invalid',
                  statusType: 'error',
                  validationType: 'pattern',
                },
              ],
            },
            inputStatus: 'neutral',
            maxLines: 1,
            placeholder: 'Enter your email!',
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: 'demo-value',
                    name: 'demo-value',
                    system: 'demo-value',
                  },
                  detail: 'salary input',
                  impression_id: '90f54b79f72db21d15ea2309b259e8f4',
                  node: {
                    id: 'core$demo-form$demoFormTextInputEmail',
                    label: 'textInputEmail',
                    parent_label: 'Form fields vertical layout',
                    parent_type: 'verticalLayout',
                    type: 'textInput',
                  },
                  product_area: 'masonry',
                  screen_name: 'demo-form',
                  sub_product_area: 'form',
                },
              },
              namespace: 'default',
              payload: {},
              type: 'onLoad',
            },
          },
        },
      },
      id: 'core$demo-form$demoFormTextInputEmail',
      links: {
        self: '/v1/masonry-node/core$demo-form$demoFormTextInputEmail?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4\u0026test=test_param',
      },
      type: 'node-data',
    },
    {
      attributes: {
        node: {
          locatorId: 'core$demo-form$demoFormTextInputPassword',
          namespace: 'default',
          type: 'textInput',
          properties: {
            formFieldProperties: {
              formFieldId: 'textInputPassword',
              formFieldType: 'password',
              formId: 'demo-form',
              hideLabel: false,
              hint: 'It should have one of uppercase, lowercase, digit and special symbol. And should be more than 4 character',
              label: 'Password field',
              showOptionalFlag: false,
              tooltipContent: "this is textInput's tooltipContent",
              tooltipIcon: 'statusInformationCircle',
              tooltipLabel: "this is textInput's tooltipLabel",
              validationRules: [
                {
                  payload: {
                    required: true,
                  },
                  statusMessage: 'This field is required',
                  statusType: 'error',
                  validationType: 'required',
                },
                {
                  payload: {
                    pattern: '[A-Z]+',
                  },
                  statusMessage:
                    'This password should have atleast 1 uppercase character',
                  statusType: 'error',
                  validationType: 'pattern',
                },
                {
                  payload: {
                    pattern: '[a-z]+',
                  },
                  statusMessage:
                    'This password should have atleast 1 lowercase character',
                  statusType: 'error',
                  validationType: 'pattern',
                },
                {
                  payload: {
                    pattern: '[0-9]+',
                  },
                  statusMessage: 'This password should have atleast 1 digit',
                  statusType: 'error',
                  validationType: 'pattern',
                },
                {
                  payload: {
                    pattern: '[^a-zA-Z0-9]+',
                  },
                  statusMessage:
                    'This password should have atleast 1 special character',
                  statusType: 'error',
                  validationType: 'pattern',
                },
                {
                  payload: {
                    minLength: 5,
                  },
                  statusMessage:
                    'This password should be atleast 5 characters long',
                  statusType: 'error',
                  validationType: 'minLength',
                },
              ],
            },
            inputStatus: 'neutral',
            maxLines: 1,
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: 'demo-value',
                    name: 'demo-value',
                    system: 'demo-value',
                  },
                  detail: 'text input password',
                  impression_id: '90f54b79f72db21d15ea2309b259e8f4',
                  node: {
                    id: 'core$demo-form$demoFormTextInputPassword',
                    label: 'textInputPassword',
                    parent_label: 'Form fields vertical layout',
                    parent_type: 'verticalLayout',
                    type: 'textInput',
                  },
                  product_area: 'masonry',
                  screen_name: 'demo-form',
                  sub_product_area: 'form',
                },
              },
              namespace: 'default',
              payload: {},
              type: 'onLoad',
            },
          },
        },
      },
      id: 'core$demo-form$demoFormTextInputPassword',
      links: {
        self: '/v1/masonry-node/core$demo-form$demoFormTextInputPassword?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4\u0026test=test_param',
      },
      type: 'node-data',
    },
    {
      attributes: {
        node: {
          locatorId: 'core$demo-form$demoFormTextInputTelephone',
          namespace: 'default',
          type: 'textInput',
          properties: {
            formFieldProperties: {
              formFieldId: 'textInputTelephone',
              formFieldType: 'tel',
              formId: 'demo-form',
              hideLabel: false,
              hint: 'Enter a phone number along with area code',
              label: 'Telephone field',
              showOptionalFlag: false,
              tooltipContent: "this is textInput's tooltipContent",
              tooltipIcon: 'statusInformationCircle',
              tooltipLabel: "this is textInput's tooltipLabel",
              validationRules: [
                {
                  payload: {
                    required: true,
                  },
                  statusMessage: 'This field is required',
                  statusType: 'error',
                  validationType: 'required',
                },
                {
                  payload: {
                    pattern:
                      '^(\\+\\d{1,2}\\s)?\\(?\\d{3}\\)?[\\s.-]\\d{3}[\\s.-]\\d{4}$',
                  },
                  statusMessage:
                    'This is not a valid telephone number. Expected format: +1 (123) 123-1234 or 123-123-1234 or 123 123 1234',
                  statusType: 'error',
                  validationType: 'pattern',
                },
              ],
            },
            inputStatus: 'neutral',
            maxLines: 1,
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: 'demo-value',
                    name: 'demo-value',
                    system: 'demo-value',
                  },
                  detail: 'text input telephone',
                  impression_id: '90f54b79f72db21d15ea2309b259e8f4',
                  node: {
                    id: 'core$demo-form$demoFormTextInputTelephone',
                    label: 'textInputTelephone',
                    parent_label: 'Form fields vertical layout',
                    parent_type: 'verticalLayout',
                    type: 'textInput',
                  },
                  product_area: 'masonry',
                  screen_name: 'demo-form',
                  sub_product_area: 'form',
                },
              },
              namespace: 'default',
              payload: {},
              type: 'onLoad',
            },
          },
        },
      },
      id: 'core$demo-form$demoFormTextInputTelephone',
      links: {
        self: '/v1/masonry-node/core$demo-form$demoFormTextInputTelephone?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4\u0026test=test_param',
      },
      type: 'node-data',
    },
    {
      attributes: {
        node: {
          locatorId: 'core$demo-form$demoFormTextInputDatePicker',
          namespace: 'default',
          type: 'textInput',
          properties: {
            formFieldProperties: {
              formFieldId: 'textInputDatePicker',
              formFieldType: 'date',
              formId: 'demo-form',
              hideLabel: false,
              hint: 'This is a Datepicker',
              label: 'A date picker',
              showOptionalFlag: false,
              tooltipContent: "this is textInput's tooltipContent",
              tooltipIcon: 'statusInformationCircle',
              tooltipLabel: "this is textInput's tooltipLabel",
              validationRules: [
                {
                  payload: {
                    required: true,
                  },
                  statusMessage: 'This field is required',
                  statusType: 'error',
                  validationType: 'required',
                },
              ],
            },
            inputStatus: 'neutral',
            maxLines: 1,
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: 'demo-value',
                    name: 'demo-value',
                    system: 'demo-value',
                  },
                  detail: 'text input date picker',
                  impression_id: '90f54b79f72db21d15ea2309b259e8f4',
                  node: {
                    id: 'core$demo-form$demoFormTextInputDatePicker',
                    label: 'textInputDatePicker',
                    parent_label: 'Form fields vertical layout',
                    parent_type: 'verticalLayout',
                    type: 'textInput',
                  },
                  product_area: 'masonry',
                  screen_name: 'demo-form',
                  sub_product_area: 'form',
                },
              },
              namespace: 'default',
              payload: {},
              type: 'onLoad',
            },
          },
        },
      },
      id: 'core$demo-form$demoFormTextInputDatePicker',
      links: {
        self: '/v1/masonry-node/core$demo-form$demoFormTextInputDatePicker?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4\u0026test=test_param',
      },
      type: 'node-data',
    },
    {
      attributes: {
        node: {
          locatorId: 'core$demo-form$demoFormTextInputReadonly',
          namespace: 'default',
          type: 'textInput',
          properties: {
            formFieldProperties: {
              formFieldId: 'textInputReadonly',
              formFieldType: 'text',
              formId: 'demo-form',
              hideLabel: false,
              label: 'Readonly field',
              showOptionalFlag: false,
              validationRules: [
                {
                  payload: {
                    required: true,
                  },
                  statusMessage: 'This field is required',
                  statusType: 'error',
                  validationType: 'required',
                },
              ],
            },
            inputStatus: 'neutral',
            maxLines: 1,
            readOnly: true,
            value: 'I am readonly',
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: 'demo-value',
                    name: 'demo-value',
                    system: 'demo-value',
                  },
                  detail: 'text input readonly',
                  impression_id: '90f54b79f72db21d15ea2309b259e8f4',
                  node: {
                    id: 'core$demo-form$demoFormTextInputReadonly',
                    label: 'textInputReadonly',
                    parent_label: 'Form fields vertical layout',
                    parent_type: 'verticalLayout',
                    type: 'textInput',
                  },
                  product_area: 'masonry',
                  screen_name: 'demo-form',
                  sub_product_area: 'form',
                },
              },
              namespace: 'default',
              payload: {},
              type: 'onLoad',
            },
          },
        },
      },
      id: 'core$demo-form$demoFormTextInputReadonly',
      links: {
        self: '/v1/masonry-node/core$demo-form$demoFormTextInputReadonly?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4\u0026test=test_param',
      },
      type: 'node-data',
    },
    {
      attributes: {
        node: {
          locatorId: 'core$demo-form$demoFormSelectInput',
          namespace: 'default',
          type: 'selectInput',
          properties: {
            disabled: false,
            formFieldProperties: {
              formFieldId: 'selectInput',
              formFieldType: 'text',
              formId: 'demo-form',
              hideLabel: false,
              hint: "this is selectInput's hint",
              label: 'Sample selectInput',
              showOptionalFlag: false,
              tooltipContent: "this is selectInput's tooltipContent",
              tooltipIcon: 'statusInformationCircle',
              tooltipLabel: "this is selectInput's tooltipLabel",
              validationRules: [
                {
                  payload: {
                    required: true,
                  },
                  statusMessage: 'This field is required',
                  statusType: 'error',
                  validationType: 'required',
                },
              ],
            },
            options: [
              {
                disabled: false,
                label: 'A',
                options: null,
                value: 'optionA',
              },
              {
                disabled: false,
                label: 'B',
                options: null,
                value: 'optionB',
              },
              {
                disabled: true,
                label: 'Disabled option',
                options: null,
                value: 'disabled',
              },
            ],
            value: 'optionB',
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: 'demo-value',
                    name: 'demo-value',
                    system: 'demo-value',
                  },
                  detail: 'select input',
                  impression_id: '90f54b79f72db21d15ea2309b259e8f4',
                  node: {
                    id: 'core$demo-form$demoFormSelectInput',
                    label: 'selectInput',
                    parent_label: 'Form fields vertical layout',
                    parent_type: 'verticalLayout',
                    type: 'selectInput',
                  },
                  product_area: 'masonry',
                  screen_name: 'demo-form',
                  sub_product_area: 'form',
                },
              },
              namespace: 'default',
              payload: {},
              type: 'onLoad',
            },
          },
        },
      },
      id: 'core$demo-form$demoFormSelectInput',
      links: {
        self: '/v1/masonry-node/core$demo-form$demoFormSelectInput?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4\u0026test=test_param',
      },
      type: 'node-data',
    },
    {
      attributes: {
        node: {
          locatorId: 'core$demo-form$demoFormSelectInputGrouped',
          namespace: 'default',
          type: 'selectInput',
          properties: {
            disabled: false,
            formFieldProperties: {
              formFieldId: 'selectInput',
              formFieldType: 'text',
              formId: 'demo-form',
              hideLabel: false,
              hint: "this is selectInput's hint",
              label: 'Sample selectInput',
              showOptionalFlag: false,
              tooltipContent: "this is selectInput's tooltipContent",
              tooltipIcon: 'statusInformationCircle',
              tooltipLabel: "this is selectInput's tooltipLabel",
              validationRules: [
                {
                  payload: {
                    required: true,
                  },
                  statusMessage: 'This field is required',
                  statusType: 'error',
                  validationType: 'required',
                },
              ],
            },
            options: [
              {
                disabled: false,
                label: 'Group A',
                options: [
                  {
                    disabled: false,
                    label: 'A1',
                    value: 'optionA1',
                  },
                  {
                    disabled: false,
                    label: 'A2',
                    value: 'optionA2',
                  },
                  {
                    disabled: true,
                    label: 'Disabled option A',
                    value: 'disabled',
                  },
                ],
                value: null,
              },
              {
                disabled: false,
                label: 'B',
                options: [
                  {
                    disabled: false,
                    label: 'B1',
                    value: 'optionB1',
                  },
                  {
                    disabled: false,
                    label: 'B2',
                    value: 'optionB2',
                  },
                ],
                value: null,
              },
              {
                disabled: true,
                label: 'Disabled group',
                options: [
                  {
                    disabled: false,
                    label: 'D1',
                    value: 'optionD1',
                  },
                  {
                    disabled: true,
                    label: 'D2',
                    value: 'optionD2',
                  },
                ],
                value: 'disabled',
              },
            ],
            value: 'optionB2',
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: 'demo-value',
                    name: 'demo-value',
                    system: 'demo-value',
                  },
                  detail: 'select input',
                  impression_id: '90f54b79f72db21d15ea2309b259e8f4',
                  node: {
                    id: 'core$demo-form$demoFormSelectInputGrouped',
                    label: 'selectInputGrouped',
                    parent_label: 'Form fields vertical layout',
                    parent_type: 'verticalLayout',
                    type: 'selectInput',
                  },
                  product_area: 'masonry',
                  screen_name: 'demo-form',
                  sub_product_area: 'form',
                },
              },
              namespace: 'default',
              payload: {},
              type: 'onLoad',
            },
          },
        },
      },
      id: 'core$demo-form$demoFormSelectInputGrouped',
      links: {
        self: '/v1/masonry-node/core$demo-form$demoFormSelectInputGrouped?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4\u0026test=test_param',
      },
      type: 'node-data',
    },
    {
      attributes: {
        node: {
          locatorId: 'core$demo-form$demoFormRadioGroupInline',
          namespace: 'default',
          type: 'radioGroup',
          properties: {
            formFieldProperties: {
              formFieldId: 'radioGroupInline',
              formFieldType: 'text',
              formId: 'demo-form',
              hideLabel: false,
              hint: "this is radioGroup's hint",
              label: 'Sample radioGroup',
              showOptionalFlag: false,
              tooltipContent: "this is radioGroup's tooltipContent",
              tooltipIcon: 'statusInformationCircle',
              tooltipLabel: "this is radioGroup's tooltipLabel",
              validationRules: [
                {
                  payload: {
                    required: true,
                  },
                  statusMessage: 'This field is required',
                  statusType: 'error',
                  validationType: 'required',
                },
              ],
            },
            layout: 'inline',
            options: [
              {
                disabled: null,
                hint: 'Select this forOption A',
                label: 'A',
                value: 'optionA',
              },
              {
                disabled: null,
                hint: 'Select this forOption B',
                label: 'B',
                value: 'optionB',
              },
              {
                disabled: null,
                hint: 'Select this forOption C',
                label: 'C',
                value: 'optionC',
              },
            ],
            value: 'optionB',
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: 'demo-value',
                    name: 'demo-value',
                    system: 'demo-value',
                  },
                  detail: 'radio group row',
                  impression_id: '90f54b79f72db21d15ea2309b259e8f4',
                  node: {
                    id: 'core$demo-form$demoFormRadioGroupInline',
                    label: 'radioGroupInline',
                    parent_label: 'Form fields vertical layout',
                    parent_type: 'verticalLayout',
                    type: 'radioGroup',
                  },
                  product_area: 'masonry',
                  screen_name: 'demo-form',
                  sub_product_area: 'form',
                },
              },
              namespace: 'default',
              payload: {},
              type: 'onLoad',
            },
          },
        },
      },
      id: 'core$demo-form$demoFormRadioGroupInline',
      links: {
        self: '/v1/masonry-node/core$demo-form$demoFormRadioGroupInline?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4\u0026test=test_param',
      },
      type: 'node-data',
    },
    {
      attributes: {
        node: {
          locatorId: 'core$demo-form$demoFormRadioGroupRow',
          namespace: 'default',
          type: 'radioGroup',
          properties: {
            formFieldProperties: {
              formFieldId: 'radioGroupRow',
              formFieldType: 'text',
              formId: 'demo-form',
              hideLabel: false,
              hint: "this is radioGroup's hint",
              label: 'Sample radioGroup',
              showOptionalFlag: false,
              tooltipContent: "this is radioGroup's tooltipContent",
              tooltipIcon: 'statusInformationCircle',
              tooltipLabel: "this is radioGroup's tooltipLabel",
              validationRules: [
                {
                  payload: {
                    required: true,
                  },
                  statusMessage: 'This field is required',
                  statusType: 'error',
                  validationType: 'required',
                },
              ],
            },
            layout: 'row',
            options: [
              {
                disabled: null,
                hint: 'Select this forOption A',
                label: 'Option A',
                value: 'optionA',
              },
              {
                disabled: null,
                hint: 'Select this forOption B',
                label: 'Option B',
                value: 'optionB',
              },
              {
                disabled: null,
                hint: 'Select this forOption C',
                label: 'Option C',
                value: 'optionC',
              },
            ],
            value: 'optionB',
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: 'demo-value',
                    name: 'demo-value',
                    system: 'demo-value',
                  },
                  detail: 'radio group row',
                  impression_id: '90f54b79f72db21d15ea2309b259e8f4',
                  node: {
                    id: 'core$demo-form$demoFormRadioGroupRow',
                    label: 'radioGroupRow',
                    parent_label: 'Form fields vertical layout',
                    parent_type: 'verticalLayout',
                    type: 'radioGroup',
                  },
                  product_area: 'masonry',
                  screen_name: 'demo-form',
                  sub_product_area: 'form',
                },
              },
              namespace: 'default',
              payload: {},
              type: 'onLoad',
            },
          },
        },
      },
      id: 'core$demo-form$demoFormRadioGroupRow',
      links: {
        self: '/v1/masonry-node/core$demo-form$demoFormRadioGroupRow?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4\u0026test=test_param',
      },
      type: 'node-data',
    },
    {
      attributes: {
        node: {
          locatorId: 'core$demo-form$demoFormRadioGroupRowDisabled',
          namespace: 'default',
          type: 'radioGroup',
          properties: {
            formFieldProperties: {
              formFieldId: 'radioGroupRowDisabled',
              formFieldType: 'text',
              formId: 'demo-form',
              hideLabel: false,
              hint: "this is radioGroup's hint",
              label: 'Sample radioGroup',
              showOptionalFlag: true,
            },
            layout: 'row',
            options: [
              {
                disabled: null,
                hint: 'Select this forOption A',
                label: 'Option A',
                value: 'optionA',
              },
              {
                disabled: true,
                hint: 'Select this forOption B',
                label: 'Option B',
                value: 'optionB',
              },
              {
                disabled: null,
                hint: 'Select this forOption C',
                label: 'Option C',
                value: 'optionC',
              },
            ],
            value: 'optionB',
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: 'demo-value',
                    name: 'demo-value',
                    system: 'demo-value',
                  },
                  detail: 'radio group row',
                  impression_id: '90f54b79f72db21d15ea2309b259e8f4',
                  node: {
                    id: 'core$demo-form$demoFormRadioGroupRowDisabled',
                    label: 'radioGroupRowDisabled',
                    parent_label: 'Form fields vertical layout',
                    parent_type: 'verticalLayout',
                    type: 'radioGroup',
                  },
                  product_area: 'masonry',
                  screen_name: 'demo-form',
                  sub_product_area: 'form',
                },
              },
              namespace: 'default',
              payload: {},
              type: 'onLoad',
            },
          },
        },
      },
      id: 'core$demo-form$demoFormRadioGroupRowDisabled',
      links: {
        self: '/v1/masonry-node/core$demo-form$demoFormRadioGroupRowDisabled?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4\u0026test=test_param',
      },
      type: 'node-data',
    },
    {
      attributes: {
        node: {
          locatorId: 'core$demo-form$demoFormCheckboxGroupInline',
          namespace: 'default',
          type: 'checkboxGroup',
          properties: {
            formFieldProperties: {
              formFieldId: 'checkboxGroupInline',
              formFieldType: 'text',
              formId: 'demo-form',
              hideLabel: false,
              hint: "this is checkboxGroup's hint",
              label: 'Sample checkboxGroup',
              showOptionalFlag: false,
              tooltipContent: "this is checkboxGroup's tooltipContent",
              tooltipIcon: 'statusInformationCircle',
              tooltipLabel: "this is checkboxGroup's tooltipLabel",
              validationRules: [
                {
                  payload: {
                    required: true,
                  },
                  statusMessage: 'This field is required',
                  statusType: 'error',
                  validationType: 'required',
                },
              ],
            },
            layout: 'inline',
            options: [
              {
                disabled: null,
                exclusive: null,
                hint: 'Select this forOption A',
                label: 'Option A',
                readOnly: null,
                value: 'optionA',
              },
              {
                disabled: null,
                exclusive: null,
                hint: 'Select this forOption B',
                label: 'Option B',
                readOnly: null,
                value: 'optionB',
              },
              {
                disabled: null,
                exclusive: null,
                hint: 'Select this forOption C',
                label: 'Option C',
                readOnly: null,
                value: 'optionC',
              },
            ],
            value: ['optionB', 'optionC'],
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: 'demo-value',
                    name: 'demo-value',
                    system: 'demo-value',
                  },
                  detail: 'checkbox group inline',
                  impression_id: '90f54b79f72db21d15ea2309b259e8f4',
                  node: {
                    id: 'core$demo-form$demoFormCheckboxGroupInline',
                    label: 'checkboxGroupInline',
                    parent_label: 'Form fields vertical layout',
                    parent_type: 'verticalLayout',
                    type: 'checkboxGroup',
                  },
                  product_area: 'masonry',
                  screen_name: 'demo-form',
                  sub_product_area: 'form',
                },
              },
              namespace: 'default',
              payload: {},
              type: 'onLoad',
            },
          },
        },
      },
      id: 'core$demo-form$demoFormCheckboxGroupInline',
      links: {
        self: '/v1/masonry-node/core$demo-form$demoFormCheckboxGroupInline?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4\u0026test=test_param',
      },
      type: 'node-data',
    },
    {
      attributes: {
        node: {
          locatorId: 'core$demo-form$demoFormCheckboxGroupRow',
          namespace: 'default',
          type: 'checkboxGroup',
          properties: {
            formFieldProperties: {
              formFieldId: 'checkboxGroupRow',
              formFieldType: 'text',
              formId: 'demo-form',
              hideLabel: false,
              hint: "this is checkboxGroup's hint",
              label: 'Sample checkboxGroup',
              showOptionalFlag: false,
              tooltipContent: "this is checkboxGroup's tooltipContent",
              tooltipIcon: 'statusInformationCircle',
              tooltipLabel: "this is checkboxGroup's tooltipLabel",
              validationRules: [
                {
                  payload: {
                    required: true,
                  },
                  statusMessage: 'This field is required',
                  statusType: 'error',
                  validationType: 'required',
                },
              ],
            },
            layout: 'row',
            options: [
              {
                disabled: null,
                exclusive: null,
                hint: 'Select this forOption A',
                label: 'Option A',
                readOnly: null,
                value: 'optionA',
              },
              {
                disabled: null,
                exclusive: null,
                hint: 'Select this forOption B',
                label: 'Option B',
                readOnly: null,
                value: 'optionB',
              },
              {
                disabled: null,
                exclusive: null,
                hint: 'Select this forOption C',
                label: 'Option C',
                readOnly: null,
                value: 'optionC',
              },
              {
                disabled: null,
                exclusive: true,
                hint: 'Select this for exclusive option',
                label: 'Exclusive Option',
                readOnly: null,
                value: 'exclusive',
              },
            ],
            value: ['optionB', 'optionC'],
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: 'demo-value',
                    name: 'demo-value',
                    system: 'demo-value',
                  },
                  detail: 'checkbox group row',
                  impression_id: '90f54b79f72db21d15ea2309b259e8f4',
                  node: {
                    id: 'core$demo-form$demoFormCheckboxGroupRow',
                    label: 'checkboxGroupRow',
                    parent_label: 'Form fields vertical layout',
                    parent_type: 'verticalLayout',
                    type: 'checkboxGroup',
                  },
                  product_area: 'masonry',
                  screen_name: 'demo-form',
                  sub_product_area: 'form',
                },
              },
              namespace: 'default',
              payload: {},
              type: 'onLoad',
            },
          },
        },
      },
      id: 'core$demo-form$demoFormCheckboxGroupRow',
      links: {
        self: '/v1/masonry-node/core$demo-form$demoFormCheckboxGroupRow?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4\u0026test=test_param',
      },
      type: 'node-data',
    },
    {
      attributes: {
        node: {
          locatorId: 'core$demo-form$demoFormCheckboxGroupRowOptional',
          namespace: 'default',
          type: 'checkboxGroup',
          properties: {
            formFieldProperties: {
              formFieldId: 'checkboxGroupOptional',
              formFieldType: 'text',
              formId: 'demo-form',
              hideLabel: false,
              hint: "this is checkboxGroup's hint",
              label: 'Optional Checkbox group',
              showOptionalFlag: true,
            },
            layout: 'row',
            options: [
              {
                disabled: null,
                exclusive: null,
                hint: 'Select this forOption A',
                label: 'Option A',
                readOnly: null,
                value: 'optionA',
              },
              {
                disabled: null,
                exclusive: null,
                hint: 'Select this forOption B',
                label: 'Option B',
                readOnly: null,
                value: 'optionB',
              },
              {
                disabled: null,
                exclusive: null,
                hint: 'Select this forOption C',
                label: 'Option C',
                readOnly: null,
                value: 'optionC',
              },
            ],
            value: ['optionB', ''],
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: 'demo-value',
                    name: 'demo-value',
                    system: 'demo-value',
                  },
                  detail: 'checkbox group row',
                  impression_id: '90f54b79f72db21d15ea2309b259e8f4',
                  node: {
                    id: 'core$demo-form$demoFormCheckboxGroupRowOptional',
                    label: 'checkboxGroupOptional',
                    parent_label: 'Form fields vertical layout',
                    parent_type: 'verticalLayout',
                    type: 'checkboxGroup',
                  },
                  product_area: 'masonry',
                  screen_name: 'demo-form',
                  sub_product_area: 'form',
                },
              },
              namespace: 'default',
              payload: {},
              type: 'onLoad',
            },
          },
        },
      },
      id: 'core$demo-form$demoFormCheckboxGroupRowOptional',
      links: {
        self: '/v1/masonry-node/core$demo-form$demoFormCheckboxGroupRowOptional?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4\u0026test=test_param',
      },
      type: 'node-data',
    },
    {
      attributes: {
        node: {
          locatorId: 'core$demo-form$demoFormCheckboxGroupRowDisabled',
          namespace: 'default',
          type: 'checkboxGroup',
          properties: {
            formFieldProperties: {
              formFieldId: 'checkboxGroupDisabled',
              formFieldType: 'text',
              formId: 'demo-form',
              hideLabel: false,
              hint: "this is checkboxGroup's hint",
              label: 'Disabled Checkbox group',
              showOptionalFlag: true,
            },
            layout: 'row',
            options: [
              {
                disabled: true,
                exclusive: null,
                hint: 'Select this forOption A',
                label: 'Option A',
                readOnly: null,
                value: 'optionA',
              },
              {
                disabled: true,
                exclusive: null,
                hint: 'Select this forOption B',
                label: 'Option B',
                readOnly: null,
                value: 'optionB',
              },
              {
                disabled: null,
                exclusive: null,
                hint: 'Select this forOption C',
                label: 'Option C',
                readOnly: null,
                value: 'optionC',
              },
            ],
            value: ['optionB', ''],
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: 'demo-value',
                    name: 'demo-value',
                    system: 'demo-value',
                  },
                  detail: 'checkbox group row',
                  impression_id: '90f54b79f72db21d15ea2309b259e8f4',
                  node: {
                    id: 'core$demo-form$demoFormCheckboxGroupRowDisabled',
                    label: 'checkboxGroupDisabled',
                    parent_label: 'Form fields vertical layout',
                    parent_type: 'verticalLayout',
                    type: 'checkboxGroup',
                  },
                  product_area: 'masonry',
                  screen_name: 'demo-form',
                  sub_product_area: 'form',
                },
              },
              namespace: 'default',
              payload: {},
              type: 'onLoad',
            },
          },
        },
      },
      id: 'core$demo-form$demoFormCheckboxGroupRowDisabled',
      links: {
        self: '/v1/masonry-node/core$demo-form$demoFormCheckboxGroupRowDisabled?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4\u0026test=test_param',
      },
      type: 'node-data',
    },
    {
      attributes: {
        node: {
          locatorId: 'core$demo-form$demoFormConditionalStack',
          namespace: 'default',
          type: 'verticalLayout',
          properties: {
            body: 'This is a stack with examples for conditional inputs. Select the payment methods to show/hide the inputs.',
            heading: 'Conditional Examples',
            isSemanticList: false,
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  detail: 'conditional inputs stack',
                  impression_id: '90f54b79f72db21d15ea2309b259e8f4',
                  node: {
                    id: 'core$demo-form$demoFormConditionalStack',
                    label: 'Stack with conditional examples',
                    parent_label: 'Form fields vertical layout',
                    parent_type: 'verticalLayout',
                    type: 'verticalLayout',
                  },
                  product_area: 'masonry',
                  screen_name: 'demo-form',
                  sub_product_area: 'forms',
                },
              },
              namespace: 'default',
              payload: {},
              type: 'onLoad',
            },
          },
        },
      },
      id: 'core$demo-form$demoFormConditionalStack',
      links: {
        self: '/v1/masonry-node/core$demo-form$demoFormConditionalStack?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4\u0026test=test_param',
      },
      relationships: {
        sections: {
          data: [
            {
              id: 'core$demo-form$demoFormConditionalStack-section-items',
              type: 'node-section',
            },
          ],
        },
      },
      type: 'node-data',
    },
    {
      attributes: {
        name: 'items',
      },
      id: 'core$demo-form$demoFormConditionalStack-section-items',
      relationships: {
        nodes: {
          data: [
            {
              id: 'core$demo-form$accountNumber',
              type: 'node-data',
            },
            {
              id: 'core$demo-form$bankName',
              type: 'node-data',
            },
            {
              id: 'core$demo-form$cardNumber',
              type: 'node-data',
            },
            {
              id: 'core$demo-form$paypalEmail',
              type: 'node-data',
            },
            {
              id: 'core$demo-form$selectPaymentMethod',
              type: 'node-data',
            },
          ],
        },
      },
      type: 'node-section',
    },
    {
      attributes: {
        node: {
          locatorId: 'core$demo-form$accountNumber',
          namespace: 'default',
          states: {
            isHidden: true,
          },
          type: 'textInput',
          properties: {
            formFieldProperties: {
              formFieldId: 'accountNumber',
              formFieldType: 'number',
              formId: 'demo-form',
              hideLabel: false,
              label: 'Account Number',
              showOptionalFlag: false,
              validationRules: [
                {
                  payload: {
                    required: true,
                  },
                  statusMessage: 'This field is required',
                  statusType: 'error',
                  validationType: 'required',
                },
              ],
            },
            inputStatus: 'neutral',
            maxLines: 1,
            placeholder: 'Account Number',
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: 'demo-value',
                    name: 'demo-value',
                    system: 'demo-value',
                  },
                  detail: 'account number',
                  impression_id: '90f54b79f72db21d15ea2309b259e8f4',
                  node: {
                    id: 'core$demo-form$accountNumber',
                    label: 'Account number',
                    parent_label: 'Stack with conditional examples',
                    parent_type: 'verticalLayout',
                    type: 'textInput',
                  },
                  product_area: 'masonry',
                  screen_name: 'demo-form',
                  sub_product_area: 'form',
                },
              },
              namespace: 'default',
              payload: {},
              type: 'onLoad',
            },
          },
        },
      },
      id: 'core$demo-form$accountNumber',
      links: {
        self: '/v1/masonry-node/core$demo-form$accountNumber?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4\u0026test=test_param',
      },
      type: 'node-data',
    },
    {
      attributes: {
        node: {
          locatorId: 'core$demo-form$bankName',
          namespace: 'default',
          states: {
            isHidden: true,
          },
          type: 'textInput',
          properties: {
            formFieldProperties: {
              formFieldId: 'bankName',
              formFieldType: 'text',
              formId: 'demo-form',
              hideLabel: false,
              label: 'Bank Name',
              showOptionalFlag: false,
              validationRules: [
                {
                  payload: {
                    required: true,
                  },
                  statusMessage: 'This field is required',
                  statusType: 'error',
                  validationType: 'required',
                },
              ],
            },
            inputStatus: 'neutral',
            maxLines: 1,
            placeholder: 'Bank Name',
            value: 'Pre-filled value',
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: 'demo-value',
                    name: 'demo-value',
                    system: 'demo-value',
                  },
                  detail: 'bank name',
                  impression_id: '90f54b79f72db21d15ea2309b259e8f4',
                  node: {
                    id: 'core$demo-form$bankName',
                    label: 'Bank name',
                    parent_label: 'Stack with conditional examples',
                    parent_type: 'verticalLayout',
                    type: 'textInput',
                  },
                  product_area: 'masonry',
                  screen_name: 'demo-form',
                  sub_product_area: 'form',
                },
              },
              namespace: 'default',
              payload: {},
              type: 'onLoad',
            },
          },
        },
      },
      id: 'core$demo-form$bankName',
      links: {
        self: '/v1/masonry-node/core$demo-form$bankName?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4\u0026test=test_param',
      },
      type: 'node-data',
    },
    {
      attributes: {
        node: {
          locatorId: 'core$demo-form$cardNumber',
          namespace: 'default',
          states: {
            isHidden: true,
          },
          type: 'textInput',
          properties: {
            formFieldProperties: {
              formFieldId: 'cardNumber',
              formFieldType: 'number',
              formId: 'demo-form',
              hideLabel: false,
              label: 'Card Number',
              showOptionalFlag: false,
              validationRules: [
                {
                  payload: {
                    required: true,
                  },
                  statusMessage: 'This field is required',
                  statusType: 'error',
                  validationType: 'required',
                },
              ],
            },
            inputStatus: 'neutral',
            maxLines: 1,
            placeholder: 'Card Number!',
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: 'demo-value',
                    name: 'demo-value',
                    system: 'demo-value',
                  },
                  detail: 'card number',
                  impression_id: '90f54b79f72db21d15ea2309b259e8f4',
                  node: {
                    id: 'core$demo-form$cardNumber',
                    label: 'Card Number',
                    parent_label: 'Stack with conditional examples',
                    parent_type: 'verticalLayout',
                    type: 'textInput',
                  },
                  product_area: 'masonry',
                  screen_name: 'demo-form',
                  sub_product_area: 'form',
                },
              },
              namespace: 'default',
              payload: {},
              type: 'onLoad',
            },
          },
        },
      },
      id: 'core$demo-form$cardNumber',
      links: {
        self: '/v1/masonry-node/core$demo-form$cardNumber?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4\u0026test=test_param',
      },
      type: 'node-data',
    },
    {
      attributes: {
        node: {
          locatorId: 'core$demo-form$paypalEmail',
          namespace: 'default',
          states: {
            isHidden: true,
          },
          type: 'textInput',
          properties: {
            formFieldProperties: {
              formFieldId: 'paypalEmail',
              formFieldType: 'email',
              formId: 'demo-form',
              hideLabel: false,
              label: 'Paypal Email',
              showOptionalFlag: false,
              validationRules: [
                {
                  payload: {
                    required: true,
                  },
                  statusMessage: 'This field is required',
                  statusType: 'error',
                  validationType: 'required',
                },
                {
                  payload: {
                    pattern: '^[^@]+@[^@]+\\.[^@]+$',
                  },
                  statusMessage: 'The email is invalid',
                  statusType: 'error',
                  validationType: 'pattern',
                },
              ],
            },
            inputStatus: 'neutral',
            maxLines: 1,
            placeholder: 'Paypal Email',
            value: 'Pre-filled value',
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: 'demo-value',
                    name: 'demo-value',
                    system: 'demo-value',
                  },
                  detail: 'paypal email',
                  impression_id: '90f54b79f72db21d15ea2309b259e8f4',
                  node: {
                    id: 'core$demo-form$paypalEmail',
                    label: 'PayPal Input',
                    parent_label: 'Stack with conditional examples',
                    parent_type: 'verticalLayout',
                    type: 'textInput',
                  },
                  product_area: 'masonry',
                  screen_name: 'demo-form',
                  sub_product_area: 'form',
                },
              },
              namespace: 'default',
              payload: {},
              type: 'onLoad',
            },
          },
        },
      },
      id: 'core$demo-form$paypalEmail',
      links: {
        self: '/v1/masonry-node/core$demo-form$paypalEmail?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4\u0026test=test_param',
      },
      type: 'node-data',
    },
    {
      attributes: {
        node: {
          locatorId: 'core$demo-form$selectPaymentMethod',
          namespace: 'default',
          type: 'selectInput',
          properties: {
            disabled: false,
            formFieldProperties: {
              formFieldId: 'selectInputConditional',
              formFieldType: 'text',
              formId: 'demo-form',
              hideLabel: false,
              hint: 'Payment Method',
              label: 'Payment Method',
              showOptionalFlag: false,
              tooltipContent: 'Select the Payment Method',
              tooltipIcon: 'statusInformationCircle',
              tooltipLabel: 'Payment Method',
              validationRules: [
                {
                  payload: {
                    required: true,
                  },
                  statusMessage: 'This field is required',
                  statusType: 'error',
                  validationType: 'required',
                },
              ],
            },
            options: [
              {
                disabled: false,
                label: 'Select the Payment Method',
                options: null,
                value: null,
              },
              {
                disabled: false,
                label: 'Credit Card',
                options: null,
                value: 'credit',
              },
              {
                disabled: false,
                label: 'Paypal',
                options: null,
                value: 'paypal',
              },
              {
                disabled: false,
                label: 'Bank Transfer',
                options: null,
                value: 'transfer',
              },
            ],
          },
          actions: {
            onChange: {
              analytics: {
                event_name: EVENT_NAME.EVENT_FIRED,
                payload: {
                  content: {
                    id: 'demo-value',
                    name: 'demo-value',
                    system: 'demo-value',
                  },
                  detail: 'select input conditional changed',
                  impression_id: '90f54b79f72db21d15ea2309b259e8f4',
                  node: {
                    id: 'core$demo-form$selectPaymentMethod',
                    label: 'Select input Conditional',
                    parent_label: 'Stack with conditional examples',
                    parent_type: 'verticalLayout',
                    type: 'selectInput',
                  },
                  product_area: 'masonry',
                  screen_name: 'demo-form',
                  sub_product_area: 'form',
                },
              },
              namespace: 'default',
              payload: {
                allNodes: [
                  'core$demo-form$cardNumber',
                  'core$demo-form$paypalEmail',
                  'core$demo-form$bankName',
                  'core$demo-form$accountNumber',
                ],
                showNodes: [
                  {
                    nodes: null,
                    value: null,
                  },
                  {
                    nodes: [
                      'core$demo-form$cardNumber',
                      'core$demo-form$bankName',
                    ],
                    value: 'credit',
                  },
                  {
                    nodes: ['core$demo-form$paypalEmail'],
                    value: 'paypal',
                  },
                  {
                    nodes: [
                      'core$demo-form$bankName',
                      'core$demo-form$accountNumber',
                    ],
                    value: 'transfer',
                  },
                ],
              },
              type: 'toggleFormFieldVisibility',
            },
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: 'demo-value',
                    name: 'demo-value',
                    system: 'demo-value',
                  },
                  detail: 'select input conditional',
                  impression_id: '90f54b79f72db21d15ea2309b259e8f4',
                  node: {
                    id: 'core$demo-form$selectPaymentMethod',
                    label: 'Select input Conditional',
                    parent_label: 'Stack with conditional examples',
                    parent_type: 'verticalLayout',
                    type: 'selectInput',
                  },
                  product_area: 'masonry',
                  screen_name: 'demo-form',
                  sub_product_area: 'form',
                },
              },
              namespace: 'default',
              payload: {},
              type: 'onLoad',
            },
          },
        },
      },
      id: 'core$demo-form$selectPaymentMethod',
      links: {
        self: '/v1/masonry-node/core$demo-form$selectPaymentMethod?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4\u0026test=test_param',
      },
      type: 'node-data',
    },
    {
      attributes: {
        node: {
          locatorId: 'core$demo-form$demoFormSelectInputDataProcessorBehavior',
          namespace: 'default',
          type: 'selectInput',
          properties: {
            disabled: false,
            formFieldProperties: {
              formFieldId: 'expectedBehavior',
              formFieldType: 'text',
              formId: 'demo-form',
              hideLabel: false,
              hint: "If the validation passes the data processor will be invoked, but it's behavior is defined by that field",
              label: 'Expected behavior of the data processor',
              showOptionalFlag: false,
              validationRules: [
                {
                  payload: {
                    required: true,
                  },
                  statusMessage: 'This field is required',
                  statusType: 'error',
                  validationType: 'required',
                },
              ],
            },
            options: [
              {
                disabled: false,
                label: 'Success',
                options: null,
                value: 'success',
              },
              {
                disabled: false,
                label: 'Slow success',
                options: null,
                value: 'slowSuccess',
              },
              {
                disabled: false,
                label: 'Error: Processing',
                options: null,
                value: 'errorProcessing',
              },
              {
                disabled: false,
                label: 'Critical error: Processing (panic)',
                options: null,
                value: 'panic',
              },
            ],
            value: 'success',
          },
        },
      },
      id: 'core$demo-form$demoFormSelectInputDataProcessorBehavior',
      links: {
        self: '/v1/masonry-node/core$demo-form$demoFormSelectInputDataProcessorBehavior?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4\u0026test=test_param',
      },
      type: 'node-data',
    },
    {
      attributes: {
        node: {
          locatorId: 'core$demo-form$demoFormSubmitButton',
          namespace: 'default',
          type: 'button',
          properties: {
            label: 'Submit',
            priority: 'primary',
            size: 'large',
            type: 'submit',
          },
          actions: {
            onClick: {
              analytics: {
                event_name: EVENT_NAME.BUTTON_CLICKED,
                payload: {
                  detail: 'submit button',
                  impression_id: '90f54b79f72db21d15ea2309b259e8f4',
                  node: {
                    id: 'core$demo-form$demoFormSubmitButton',
                    label: 'submitButton',
                    parent_label: 'Form fields vertical layout',
                    parent_type: 'verticalLayout',
                    type: 'button',
                  },
                  product_area: 'masonry',
                  screen_name: 'demo-form',
                  sub_product_area: 'form',
                },
              },
              namespace: 'default',
              payload: {
                formId: 'demo-form',
                formProcessorId: 'masonrySample',
                onSuccessDeepLink: '/member/about-me?view=achievements',
                suppressErrorModal: false,
              },
              type: 'submitForm',
            },
          },
        },
      },
      id: 'core$demo-form$demoFormSubmitButton',
      links: {
        self: '/v1/masonry-node/core$demo-form$demoFormSubmitButton?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4\u0026test=test_param',
      },
      type: 'node-data',
    },
    {
      attributes: {
        node: {
          locatorId: 'demoForm-footer-LocatorId',
          namespace: 'default',
          type: 'imageBanner',
          properties: {
            image:
              'https://images.ctfassets.net/s9gs3yjnjpji/5hRVfLjPI7XvI87bUp90D/6585f41fe6c926190f942d3687c8c6f3/PBL-Logo-EN.png',
            imageAlignment: 'center',
            imageAltText: 'This is a imageBanner Powered by League',
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  detail: 'footer',
                  impression_id: '90f54b79f72db21d15ea2309b259e8f4',
                  node: {
                    id: 'core$demo-form$demoFormFooter',
                    label: 'ImageBanner Card',
                    parent_label: 'Demo form v2 root node',
                    parent_type: 'verticalLayout',
                    type: 'imageBanner',
                  },
                  product_area: 'masonry',
                  screen_name: 'demo-form',
                  sub_product_area: 'form',
                },
              },
              namespace: 'default',
              payload: {},
              type: 'onLoad',
            },
          },
        },
      },
      id: 'core$demo-form$demoFormFooter',
      links: {
        self: '/v1/masonry-node/core$demo-form$demoFormFooter?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4\u0026test=test_param',
      },
      type: 'node-data',
    },
  ],
  links: {
    self: '/v1/masonry-node/core$demo-form$root?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4\u0026test=test_param',
  },
};
